import { lazy } from "react";

// -------- PUBLIC --------
const Login = lazy(() => import("./auth/page.login.jsx"));
const Signup = lazy(() => import("@auth/page.signUp.jsx"));
const ForgotPassword = lazy(
  () => import("./auth/form.email.forgot.password.jsx"),
);
const Terms = lazy(() => import("./pages/page.public.terms&conditions.jsx"));
const Privacy = lazy(() => import("./pages/page.public.privacyPolicy.jsx"));
const PublicProfile = lazy(() => import("./pages/page.public.profile.jsx"));
const SignupWorkflow = lazy(() => import("@pages/page.signup"));

// -------- COMMON / PRIVATE --------
// const Dashboard = lazy(() => import("./pages/page.dashboard"));
const Dashboard = lazy(() => import("./pages/page.dashboard"));
const Jobs = lazy(() => import("./pages/page.jobs"));
const JobDetails = lazy(() => import("./pages/page.job.jsx"));
const ProjectDetails=lazy(()=> import("./pages/page.project.jsx"));
const AIMatches=lazy(()=> import("./pages/page.AI.Matches.jsx"));
const Profiles = lazy(() => import("./pages/page.public.profiles.jsx"));
const Inbox = lazy(() => import("./pages/page.inbox"));
const Discover = lazy(() => import("./pages/page.discover.jsx"));
const Notifications = lazy(() => import("./pages/page.notification"));
const Playground = lazy(() => import("./pages/page.playground"));
const Competition = lazy(() => import("./pages/page.competition.jsx"));
const Institution = lazy(() => import("./pages/page.institution.jsx"));
const ScriptDetails = lazy(() => import("./pages/page.script.jsx"));
// const Settings = lazy(() => import("./pages/page.settings.jsx"));
const Settings = lazy(() => import("./pages/page.settings.jsx"));
const ArtistProfile = lazy(() => import("./pages/page.profile.jsx"));
const SelectRole=lazy(()=>import("./auth/page.role.jsx"));

// -------- RECRUITER --------
const CreateJob = lazy(() => import("./pages/page.create.jsx"));

export const publicRoutes = {
  "":SelectRole,
  termandconditions: Terms,
  privacypolicy: Privacy,
  login: Login,
  signup: Signup,
  "home":SelectRole,
  forgotPassword: ForgotPassword,
  "application/:steps": SignupWorkflow,

  ":id": PublicProfile,
  "login/:id": Login,
  "signup/:id": Signup,
  "forgotPassword/:id": ForgotPassword,
};

const withMobile = (Component, isMobile) => <Component isMobile={isMobile} />;

export const commonRoutes = (isMobile) => ({
  dashboard: () => <Dashboard isMobile={isMobile} />,

  jobs: () => withMobile(Jobs, isMobile),
  "jobs/:id": () => withMobile(Jobs, isMobile),

  artists: () => withMobile(Profiles, isMobile),
  "artists/:id": () => withMobile(Profiles, isMobile),
  "artist-details/:id": () => withMobile(PublicProfile, isMobile),

  inbox: () => withMobile(Inbox, isMobile),
  discover: () => withMobile(Discover, isMobile),
  "discover/:id": () => withMobile(Discover, isMobile),

  profile: () => withMobile(ArtistProfile, isMobile),

  playground: () => withMobile(Playground, isMobile),
  notifications: () => withMobile(Notifications, isMobile),

  "job-details/:id": () => withMobile(JobDetails, isMobile),
  "institution-details/:id": () => withMobile(Institution, isMobile),
  "competition-details/:id": () => withMobile(Competition, isMobile),
  "script-details/:id": () => withMobile(ScriptDetails, isMobile),

  settings: () => withMobile(Settings, isMobile),
  "settings/:id": () => withMobile(Settings, isMobile),
  "settings/:id/:cat": () => withMobile(Settings, isMobile),
  "settings/:id/:cat/:subcat": () => withMobile(Settings, isMobile),
});

export const artistRoutes = (isMobile) => ({
  ...commonRoutes(isMobile),
});

export const recruiterRoutes = (isMobile) => ({
  create: () => withMobile(CreateJob, isMobile),
  "project/details/:id":()=>withMobile(ProjectDetails,isMobile),
  "aimatches":()=>withMobile(AIMatches,isMobile),
  "create/:id": () => withMobile(CreateJob, isMobile),
  ...commonRoutes(isMobile),
});
